



















































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import {
  Button,
  Form,
  FormItem,
  Input
} from 'element-ui';
import ModalCard from '@/components/layout/ModalCard.vue';
import { userService } from '@/services/UserService';
import { i18n } from '@/plugins/i18n';

// mixins
import scrollError from '@/mixins/scrollError';

@Component({
  components: {
    ModalCard,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class CompanyEdit extends Mixins(scrollError) {
  @Prop({ default: false, type: Boolean }) open!: boolean;

  private loading = false;
  private formInput = {
    currentPassword: '',
    password: '',
    passwordConfirmation: ''
  };

  // this custom rules need access to another form field so need to be here
  private rules = {
    currentPassword: [
      {
        type: 'string',
        required: true,
        message: i18n.t('validation.password.required'),
        trigger: 'blur'
      }
    ],
    password: [
      {
        min: 6,
        message: i18n.t('validation.new-password.min'),
        trigger: 'blur'
      }, {
        type: 'string',
        required: true,
        message: i18n.t('validation.new-password.required'),
        trigger: 'blur'
      }
    ],
    passwordConfirmation: [
      {
        type: 'string',
        required: true,
        message: i18n.t('validation.password-confirmation.required'),
        trigger: 'blur'
      }, {
        validator: this.passwordConfirmation,
        message: i18n.t('validation.password-confirmation.no-match'),
        trigger: 'blur'
      }
    ]
  };

  $refs!: {
    passwordForm: HTMLFormElement;
  };

  // this custom rules need access to another form field so need to be here
  private passwordConfirmation(rules: any, value: any, callback: any) {
    if (!value || value !== this.formInput.password) {
      callback(new Error());
    } else {
      callback();
    }
  }

  private submit(): void {
    this.$refs.passwordForm.validate(async(valid: boolean) => {
      if (!valid) {
        this.scrollError(this.$refs.passwordForm);
        return;
      }

      this.loading = true;
      try {
        const response = await userService.updatePassword(this.formInput);
        if (response.data) {
          this.$emit('close');
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.updated'),
            time: 2000
          });
          this.$refs.passwordForm.resetFields();
        }
      } catch (e) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      } finally {
        this.loading = false;
      }
    });
  }
}
